const formattedMoney = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND', // Change to your desired currency code (e.g., 'EUR' for Euro)
});

export default formattedMoney;
